import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

const SectionCard2: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.SectionCard2');

    return (
        <div className={styles.SectionCard2} id="SectionCard2" data-section-id={styles.SectionCard2} data-section-title={t('title')}>
            <EcoSpace />
            <EcoSectionCommon
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn')}
                lHref={`https://www.ecoflow.com/${locale}/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage`}
                lDataLayer={{
                    __btn_id1: styles.SectionCard2,
                    __btn_id2: `https://www.ecoflow.com/${locale}/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage`,
                }}
            />
            <div className="eco-content">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/figma-uploads/1755143834328-0mgc1h-compressed-Frame%201000009276.jpg"
                    pad="https://websiteoss.ecoflow.com/figma-uploads/1755143834328-0mgc1h-compressed-Frame%201000009276.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1755596616590/Frame%201000009277.png"
                />
                <EcoImg className="img-flag" pc="https://websiteoss.ecoflow.com/upload/image/1755152965798/15year_eu.png" />
            </div>
        </div>
    );
};

export default SectionCard2;
